// extracted by mini-css-extract-plugin
export default {"card":"ContactPage_card__12Jlj","toast":"ContactPage_toast__Py9gf"};